import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this._userScrolled = false
    this._isStreaming = false

    // On connect (opening a chat), scroll to bottom to show latest messages
    this.scrollToBottom()

    // Track if user manually scrolled up
    this._onScroll = () => {
      const el = this.element
      const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight
      // If user scrolled more than 100px from bottom, they're reading history
      this._userScrolled = distanceFromBottom > 100
    }
    this.element.addEventListener('scroll', this._onScroll)

    // Watch for streaming updates (loader steps, partial content)
    this.observer = new MutationObserver(() => {
      // Only auto-scroll if we're streaming AND user hasn't scrolled up
      if (this._isStreaming && !this._userScrolled) {
        this.scrollToBottom()
      }
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.removeEventListener('scroll', this._onScroll)
  }

  itemTargetConnected(element) {
    // A new message was added (user or AI)
    if (element.querySelector('.laz-av')) {
      // AI response — scroll to show the start of the response, then track streaming
      this._isStreaming = true
      this._userScrolled = false
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
    } else {
      // User message — always scroll to bottom
      this._userScrolled = false
      this._isStreaming = true
      this.scrollToBottom()
    }
  }

  // Call this when streaming is done (e.g., final response rendered)
  streamingDone() {
    this._isStreaming = false
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
